function ParallaxItems() {
	var self = this;
	self.init();
}

ParallaxItems.prototype.init = function() {
	var self = this;
	self.handleScrollParallax();
	// $(window).on('resize', this, this.handleScrollParallax.bind(self));
};

ParallaxItems.prototype.handleScrollParallax = function() {
	var self = this;
	
	var images = document.querySelectorAll('.img-container > img');

	var bgImages = document.querySelectorAll('.background-image > img');

	self.imgParallax = new simpleParallax(images, {
		delay: 0.6,
		scale: 1.3,
	});

	self.bgParallax = new simpleParallax(bgImages, {
		delay: 0.6,
		scale: 1.3,
	});

	var bannerImg = document.querySelectorAll('.banner-image.-large');

	self.bannerParallax = new simpleParallax(bannerImg, {
		delay: 0.6,
		scale: 1.3,
	});
};